<template>
    <div id="mobile-viewport">
        <LanguageChangingButton class="lang-btn" device="mobile" />
        <WebLogo class="web-logo" device="mobile" />
        <div class="content">
            <ControlPanelM class="control-panel" />
            <CardViewM />
            <CardButtonViewM />
        </div>
        <Footer class="footer" device="mobile" />
    </div>
</template>

<script setup>
import WebLogo from '@/components/common/WebLogo.vue'
import ControlPanelM from '@/components/mobile/ControlPanelM.vue'
import CardViewM from '@/components/mobile/CardViewM.vue'
import CardButtonViewM from '@/components/mobile/CardButtonViewM.vue'
import Footer from '@/components/common/Footer.vue'
import LanguageChangingButton from '../common/LanguageChangingButton.vue'
</script>

<style lang="scss" scoped>
#mobile-viewport {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-size: cover;
    background-repeat: no-repeat;

    @media (orientation: portrait) {
        background-image: linear-gradient(rgba(245, 245, 245, 0.5), rgba(245, 245, 245, 0.5)),
            url('~@/assets/background/mb-bg-paper.png');
        background-position: right center;
    }
    @media (orientation: landscape) {
        background-image: linear-gradient(rgba(245, 245, 245, 0.5), rgba(245, 245, 245, 0.5)),
            url('~@/assets/background/bg-paper01.png');
        background-size: cover;
    }
}
.lang-btn {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 100;
    width: 2rem;
    padding: 2.5px 4px;
}

@media (orientation: portrait) {
    .content {
        height: fit-content;
        width: 100vw;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
    }
    .web-logo {
        width: 100vw;
    }
    .control-panel {
        height: fit-content;
        width: 90%;
    }
}
@media (orientation: landscape) {
    .web-logo {
        height: 16vh;
        width: 100%;
    }
    .content {
        height: 76vh;
        width: 100vw;
        padding: 4vh 0;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;

        .control-panel {
            height: fit-content;
            width: 20vw;
        }
    }
}
</style>
